module.exports = __webpack_public_path__ + "img/sticker_7.55c9120e.svg";